import $ from 'jquery';

/**
 * Enterキーでクリックイベントを実行する関数
 * @param {HTMLElement} element - 対象要素
 */
function initEnterToClick(element) {
    const $element = $(element);
    
    $(document.forms).on('keypress', function(e) {
        if (e.key === 'Enter') {
            $element.trigger('click');
        }
    });
}

/**
 * Enterキーでカスタム関数を実行する関数
 * @param {HTMLElement} element - 対象要素
 * @param {Function} callback - 実行する関数
 */
function initEnterToAction(element, callback) {
    if (typeof callback !== 'function') {
        console.warn('enterToAction: callback must be a function');
        return;
    }
    
    const $element = $(element);
    
    $element.on('keypress', function(e) {
        if (e.key === 'Enter') {
            return callback.call(this, e);
        }
    });
}

/**
 * Enterキーで指定したターゲット要素をクリックする関数
 * @param {HTMLElement} element - 対象要素
 * @param {string} targetSelector - クリックするターゲット要素のセレクター
 */
function initEnterToTarget(element, targetSelector) {
    const $element = $(element);
    
    $element.on('keypress', function(e) {
        if (e.key === 'Enter') {
            const $target = $(targetSelector);
            if ($target.length > 0) {
                $target.trigger('click');
                return false;
            } else {
                console.warn(`enterToTarget: target "${targetSelector}" not found`);
            }
        }
    });
}

/**
 * data属性による初期化関数
 * @param {HTMLElement} elem - 初期化対象の要素（デフォルト: document）
 */
export function initEnterBindings(elem = document) {
    // data-enter-click属性を持つ要素を初期化
    const clickElements = [].slice.call(elem.querySelectorAll('[data-enter-click]'));
    clickElements.forEach(function(element) {
        initEnterToClick(element);
    });
    
    // data-enter-target属性を持つ要素を初期化
    const targetElements = [].slice.call(elem.querySelectorAll('[data-enter-target]'));
    targetElements.forEach(function(element) {
        const targetSelector = element.getAttribute('data-enter-target');
        if (targetSelector) {
            initEnterToTarget(element, targetSelector);
        } else {
            console.warn('enterToTarget: data-enter-target attribute is empty');
        }
    });
    
    // data-enter-action属性を持つ要素を初期化
    const actionElements = [].slice.call(elem.querySelectorAll('[data-enter-action]'));
    actionElements.forEach(function(element) {
        const actionName = element.getAttribute('data-enter-action');
        
        // グローバル関数として定義されたアクションを実行
        if (typeof window[actionName] === 'function') {
            initEnterToAction(element, window[actionName]);
        } else {
            console.warn(`enterToAction: function "${actionName}" not found`);
        }
    });
}

// jQueryプラグインとして登録
$.fn.bindEnter = function(callback) {
    return this.each(function() {
        const $element = $(this);
        
        $element.on('keypress', function(e) {
            if (e.key === 'Enter') {
                if (typeof callback === 'function') {
                    return callback.call(this, e);
                }
            }
        });
    });
};
